import { IconType } from 'react-icons';

interface TextWithIconProps {
    icon: IconType;
    text: string;
    className?: string;
    iconColor?: string;
}

export default function TextWithIcon({ icon: Icon, text, className, iconColor }: TextWithIconProps) {
    const urlRegex = /(https?:\/\/[^\s]+)/;
    const match = text.match(urlRegex);

    const hasUrl = !!match;
    const url = match ? match[0] : null;
    const prefix = hasUrl ? text.split(url!)[0].trim() : text;

    const shortUrl = url ? url.replace(/^https?:\/\//, '').replace(/\/$/, '') : '';

    return (
        <div className={`flex items-center gap-2 ${className || ''}`}>
            <div className='w-4 h-4'>
                <Icon color={iconColor || ''} width={16} />
            </div>
            {hasUrl ? (
                <span className="text-bmedium text-system-light-40">
                    {prefix && `${prefix} `}
                    <a
                        href={url!}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-system-light-70 transition-colors"
                    >
                        {shortUrl}
                    </a>
                </span>
            ) : (
                <span className="text-bmedium text-system-light-40">{text}</span>
            )}
        </div>
    );
}